import { render, staticRenderFns } from "./ExpansionPanel.vue?vue&type=template&id=a77aa85c&scoped=true&"
import script from "./ExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanel.vue?vue&type=style&index=0&id=a77aa85c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77aa85c",
  null
  
)

export default component.exports